import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { useOrderBy } from "../../../../hooks/useOrderBy";
import { useQuery } from "react-query";
import { indexStudentNotes } from "../../../../api/endpoints/supervisors/students";
import { ApiCommonParams } from "../../../../api/@types/apiTypes";
import { showApiErrorMessages } from "../../../../helpers";
import NoteModel from "../../../../api/models/NoteModel";
import TableHeaderCell from "../../../../components/table-cell/TableHeaderCell";
import { getNoteState } from "../../../../components/sessions/helper";
import SessionModel from "../../../../api/models/SessionModel";
type NotesTabProps = {
  session: SessionModel | null;
};
export default function NotesTab(props: NotesTabProps) {
  const { session } = props;
  const LocalBasePath = "page.supervisor.student";
  const { t } = useTranslation("", { keyPrefix: LocalBasePath });
  const { orderBy, getSortingDirection, handleSetSortingOrder } = useOrderBy();
  const { id } = useParams();
  const [filters, setFilters] = useState<{ [key: string]: any }>({});

  const { data: notes } = useQuery(
    ["studentNotes", id, orderBy, filters, session?.student?.id],
    () => {
      let apiParams: ApiCommonParams = {
        filters: {
          order_by: "-created_at",
        },
      };
      return indexStudentNotes(session?.student?.id ?? "", apiParams);
    },
    {
      select: (response) => {
        let fetchedNotes: NoteModel[] = [];
        if (response.isSuccess) {
          fetchedNotes = NoteModel.fromApiResponse(response.data);
        } else {
          showApiErrorMessages(response);
        }
        const paginationInfo = response.pagination;
        return { data: fetchedNotes, paginationInfo };
      },
      enabled: !!session?.student?.id,
    }
  );
  const updateFilterState = (state: string) => {
    setFilters({ state });
  };
  return (
    <div className="w-full flex flex-col  bg-gray-50 mb-2  min-h-screen   ">
      <div className="flex flex-col justify-between">
        <div className="">
          <div className="w-full h-px bg-gray-200" />
          {notes?.data?.length! > 0 ? (
            <>
              <table
                data-cy="notesTable"
                className="min-w-full divide-y table-fixed  divide-gray-300 "
              >
                <thead className="bg-gray-50">
                  <tr>
                    <TableHeaderCell className="text-justify">
                      {t("note")}
                    </TableHeaderCell>
                    <TableHeaderCell
                      className="w-[128px] text-justify"
                      sortable={true}
                      sortingDirection={getSortingDirection("state")}
                      onClick={handleSetSortingOrder("state")}
                    >
                      {t("status")}
                    </TableHeaderCell>
                  </tr>
                </thead>
                <tbody>
                  {notes?.data.map((note, index) => {
                    return (
                      <tr
                        key={`NoteInfoTable_${index}_note`}
                        className={" border-t "}
                      >
                        <td
                          className={"relative py-4 pl-4 sm:pl-6 pr-3 text-sm"}
                        >
                          <div className="font-medium text-gray-500">
                            {note.note}
                          </div>
                        </td>
                        <td
                          className={
                            " px-3 py-3.5 text-sm text-gray-500 lg:table-cell"
                          }
                        >
                          {getNoteState(note?.status!)}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </>
          ) : (
            <>
              <div className="flex h-[30vh] justify-center items-end">
                <h1>{t("noresultsfound")}</h1>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
